import { Injectable } from '@angular/core';

type ClientLogLevel = 'Debug' | 'Info' | 'Error';

@Injectable()
export class SpaLogger {
	private _logLevel: number = 1;

	get logLevel(): number {
		return window['overrideLogLevel'] || this._logLevel;
	}

	set logLevel(value: number) {
		this._logLevel = value;
	}

	log(logLevel: ClientLogLevel, tags: string[], text: string, data: unknown = null, _stackTrace: string = null) {
		let levelColor = 'grey';
		if (logLevel === 'Debug') {
			levelColor = 'blue';
		} else if (logLevel === 'Error') {
			levelColor = 'red';
		}

		if (this.logLevel === 3) {
			console.log(
				`%c-${logLevel.toUpperCase()}- %c[${tags.join('][')}] %c${text}`,
				`color: ${levelColor};font-weight:bold;font-size:14px;`,
				'font-weight:bold;color: #008296;',
				'color: #59b6c4;',
				data,
			);
		}
	}
}
